export default {"src":"/_next/static/media/0x321162cd933e2be498cd2267a90534a804051b11.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};